import { SupportedChainId } from "./chains";
import { utils } from "ethers";

export const NetworkContextName = "NETWORK";
export const DEFAULT_DEADLINE_FROM_NOW = 60 * 30;
export const INITIAL_ALLOWED_SLIPPAGE = 50;

export const TIME_90_DAYS = 7776000000;
export const TIME_180_DAYS = 7776000000 * 2;

export const REWARD_PER_BLOCK = 0.5;

//config mainnet
export const NETWORK_BSC = Number(process.env.NEXT_PUBLIC_BSC_CHAINID);
export const NETWORK_FUJI = Number(process.env.NEXT_PUBLIC_CHAINID) || Number('43114');

export const SUPPORTED_NETWORKS: {
  [chainId in SupportedChainId]?: {
    chainId: string;
    chainName: string;
    nativeCurrency: {
      name: string;
      symbol: string;
      decimals: number;
    };
    rpcUrls: string[];
    blockExplorerUrls: string[];
  };
} = {
  [SupportedChainId.FUJI]: {
    chainId: utils.hexValue(NETWORK_FUJI),
    chainName: "AVAX",
    nativeCurrency: {
      name: "AVAX",
      symbol: "AVAX",
      decimals: 18,
    },
    rpcUrls: ["https://api.avax.network/ext/bc/C/rpc"],
    blockExplorerUrls: ["https://snowtrace.io"],
  },
};

// export const SUPPORTED_NETWORKS: {
//   [chainId in SupportedChainId]?: {
//     chainId: string;
//     chainName: string;
//     nativeCurrency: {
//       name: string;
//       symbol: string;
//       decimals: number;
//     };
//     rpcUrls: string[];
//     blockExplorerUrls: string[];
//   };
// } = {
//   [SupportedChainId.BSC]: {
//     chainId: "56",
//     chainName: "BSC",
//     nativeCurrency: {
//       name: "Binance Coin",
//       symbol: "BNB",
//       decimals: 18,
//     },
//     rpcUrls: ["https://bsc-dataseed.binance.org/"],
//     blockExplorerUrls: ["https://bscscan.com"],
//   },
// };
